import React from 'react';
class Rest extends React.Component{
    render()
    {
        return(
            <div className="card border-0 shadow my-5">
                <div className="card-body p-5">
            <div className = "reg"  >
                <h1  align="center" style={{padding:20}}>Register</h1>
                <div align="center">
                <iframe  src="https://docs.google.com/forms/d/e/1FAIpQLSeIIoDXoHwLbZyjyBeT_s5RP_j25gtAndVw02Um_W8qqMSPYg/viewform?embedded=true" height ="600px" width="600px">Loading…</iframe>
           
                </div>
                </div>
                </div>
              
            </div>
            )
    }
}

export default Rest